import { g as a } from "../../utils-BOfnFgIH.js";
import { I as s } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as l, normalizeClass as d, createElementVNode as t } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconJcb",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(s).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return s[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = a();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ t("rect", {
  x: ".25",
  y: "3.75",
  width: "23.5",
  height: "16.5",
  rx: "1.75",
  fill: "#fff",
  stroke: "#E3E5E8",
  "stroke-width": ".5"
}, null, -1), h = ["fill"], f = ["fill"], p = ["fill"], m = ["id"], g = /* @__PURE__ */ t("stop", { "stop-color": "#58B03A" }, null, -1), D = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#55B330"
}, null, -1), I = [
  g,
  D
], b = ["id"], v = /* @__PURE__ */ t("stop", { "stop-color": "#0F6EB6" }, null, -1), q = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#006DBA"
}, null, -1), y = [
  v,
  q
], E = ["id"], S = /* @__PURE__ */ t("stop", { "stop-color": "#DE0D3D" }, null, -1), $ = /* @__PURE__ */ t("stop", {
  offset: "1",
  "stop-color": "#E30138"
}, null, -1), w = [
  S,
  $
];
function x(e, B, o, U, O, i) {
  return l(), n("svg", {
    "aria-label": o.ariaLabel,
    class: d([i.iconSizeClass, "d-icon d-icon--jcb"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Jcb",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _,
    t("path", {
      d: "M15.424 12.393c.375.008.752-.017 1.126.013.378.07.469.643.133.83-.23.124-.502.047-.75.069h-.51v-.912Zm1.342-1.032c.084.295-.2.559-.483.518h-.86c.007-.277-.01-.578.01-.84.344.009.691-.02 1.033.014a.41.41 0 0 1 .3.308Zm2.068-4.36c.016.561.002 1.152.007 1.725-.001 2.33.002 4.66-.002 6.99-.015.873-.789 1.631-1.656 1.649-.868.003-1.736 0-2.604.001v-3.522c.946-.005 1.892.01 2.837-.007.439-.028.92-.317.94-.8.051-.485-.406-.82-.84-.873-.166-.004-.161-.048 0-.068.414-.09.74-.517.618-.946-.104-.451-.603-.626-1.018-.625-.845-.006-1.691-.001-2.537-.003.006-.657-.011-1.315.01-1.972.066-.858.86-1.565 1.714-1.55h2.53Z",
      fill: `url(#${e.uniqueID}a)`
    }, null, 8, h),
    t("path", {
      d: "M5.022 8.638c.022-.871.8-1.624 1.665-1.636.865-.003 1.73 0 2.594-.002-.002 2.917.005 5.834-.003 8.75-.034.861-.802 1.6-1.659 1.615-.866.003-1.732 0-2.599.001v-3.64c.842.198 1.724.283 2.583.151.513-.083 1.074-.335 1.248-.867.128-.455.056-.935.075-1.402v-1.086H7.44c-.006.718.014 1.438-.01 2.155-.04.44-.477.72-.893.705C6.022 13.388 5 13.01 5 13.01c-.002-1.345.015-3.03.022-4.37Z",
      fill: `url(#${e.uniqueID}b)`
    }, null, 8, f),
    t("path", {
      d: "M9.835 10.96c-.078.017-.015-.266-.035-.374.005-.678-.011-1.358.009-2.036.067-.86.866-1.57 1.724-1.55h2.528c-.002 2.917.005 5.834-.004 8.75-.033.861-.802 1.6-1.658 1.615-.866.003-1.733 0-2.6.001v-3.989c.592.486 1.397.561 2.134.563a7.16 7.16 0 0 0 1.648-.214v-.731c-.608.303-1.323.496-1.998.321a1.088 1.088 0 0 1-.804-1.057c-.054-.504.242-1.037.738-1.187.616-.193 1.287-.046 1.864.205.124.065.25.145.2-.062v-.574c-.966-.23-1.993-.314-2.963-.064a2.175 2.175 0 0 0-.783.383Z",
      fill: `url(#${e.uniqueID}c)`
    }, null, 8, p),
    t("defs", null, [
      t("linearGradient", {
        id: `${e.uniqueID}a`,
        x1: "14.55",
        y1: "11.962",
        x2: "18.814",
        y2: "11.962",
        gradientUnits: "userSpaceOnUse"
      }, I, 8, m),
      t("linearGradient", {
        id: `${e.uniqueID}b`,
        x1: "4.93",
        y1: "12.283",
        x2: "9.211",
        y2: "12.283",
        gradientUnits: "userSpaceOnUse"
      }, y, 8, b),
      t("linearGradient", {
        id: `${e.uniqueID}c`,
        x1: "9.793",
        y1: "12.062",
        x2: "14.06",
        y2: "12.062",
        gradientUnits: "userSpaceOnUse"
      }, w, 8, E)
    ])
  ], 10, u);
}
const A = /* @__PURE__ */ r(c, [["render", x]]);
export {
  A as default
};
//# sourceMappingURL=jcb.js.map
